import { useGetSettingsQuery, useGetTenantsQuery } from "./api"
import { useMaybeTenant } from "@/auth"

/**
 * The workspace the sidebar should reflect. Prefers the slug in the URL
 * (/t/:slug); on slug-less pages like /myprofiles it falls back to the
 * last-used workspace, then to the first workspace the user belongs to — so
 * the tenant menu stays visible and the Personal Workspace (the default
 * current tenant for new Users, product.md §4.2) is the natural fallback.
 *
 * Unlike useCurrentTenant, this resolves from the header-free getTenants /
 * getSettings queries, so it works where no Tenant-Slug header is set.
 */
export default function useEffectiveTenantSlug(): string | undefined {
  const urlSlug = useMaybeTenant()
  const { data: settings } = useGetSettingsQuery()
  const { data: tenants } = useGetTenantsQuery()

  return urlSlug ?? settings?.currentTenantSlug ?? tenants?.[0]?.slug
}
